import { useApp } from '../context.js';
import { Heart } from '../icons.jsx';

export default function PasscodeScreen() {
    const { handlePasscodeSubmit, passcodeInput, passcodeShake, setPasscodeInput, showPasscodeError, t } = useApp();
    return (
        <div className={`min-h-screen bg-gradient-to-br ${t.bg} flex items-center justify-center p-4 ${t.themeClass}`}>
            <div className="bg-white/90 apple-card rounded-3xl p-8 shadow-xl max-w-sm w-full">
                <div className="text-center mb-6">
                    <div className="flex items-center justify-center gap-2 mb-3">
                        <Heart size={40} className="animate-heartbeat" />
                    </div>
                    <h1 className="text-3xl font-bold text-gray-800 mb-2">Our Restaurants</h1>
                    <p className="text-sm text-gray-600">Enter passcode to continue</p>
                </div>

                <div className="space-y-4">
                    <input
                        type="password"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        value={passcodeInput}
                        onChange={(e) => setPasscodeInput(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && handlePasscodeSubmit()}
                        placeholder="Enter passcode"
                        className={`w-full px-4 py-4 border-2 border-gray-200 rounded-xl focus:outline-none transition-colors text-center text-2xl tracking-widest ${passcodeShake ? 'shake border-red-400' : ''}`}
                        maxLength="4"
                    />

                    {showPasscodeError && (
                        <p className="text-red-500 text-sm text-center animate-fadeIn">
                            Incorrect passcode. Try again.
                        </p>
                    )}

                    <button
                        onClick={handlePasscodeSubmit}
                        className={`w-full bg-gradient-to-r ${t.accent} text-white px-6 py-4 rounded-xl font-semibold apple-button shadow-lg`}
                    >
                        Unlock
                    </button>
                </div>
            </div>
        </div>
    );
}
